import { Logger, StepPackage, Step, WorkflowContext, EventCallbackFunction } from '@samelogic/steps';

export class MockStep extends Step<Record<string, string>> {
  onEventTriggered: EventCallbackFunction | undefined;
  name = 'MockStep';
  async run(_context: WorkflowContext, _props: Record<string, string>): Promise<void> {
    return Promise.resolve();
  }
  constructor(logger: Logger) {
    super(logger);
  }
}
export const schema = {
  events: {
    OnRun: {
      title: 'OnRun Schema',
      type: 'object',
      properties: {
        key: {
          type: 'string'
        },
        value: {
          type: 'string'
        }
      },
      additionalProperties: false,
      required: ['key', 'value']
    }
  },
  props: {
    title: 'Props Schema',
    type: 'object',
    properties: {
      prop1: {
        type: 'string'
      },
      prop2: {
        type: 'string'
      },
      intProp: {
        type: 'integer'
      }
    },
    additionalProperties: false,
    required: ['prop1', 'intProp']
  }
};

export const stepPackage = {
  module: MockStep,
  schema: schema
} as StepPackage;
